var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5257 62.4198C48.7709 63.2337 45.5153 63.6094 41.6962 63.6094H22.9136C19.0944 63.6094 15.8388 63.2337 13.084 62.4198C13.7727 54.2807 22.1309 47.8633 32.3049 47.8633C42.4788 47.8633 50.837 54.2807 51.5257 62.4198V62.4198Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 1H22.913C7.26087 1 1 7.26087 1 22.913V41.6957C1 53.5287 4.5687 60.0087 13.0835 62.4191C13.7722 54.28 22.1304 47.8626 32.3044 47.8626C42.4783 47.8626 50.8365 54.28 51.5252 62.4191C60.04 60.0087 63.6087 53.5287 63.6087 41.6957V22.913C63.6087 7.26087 57.3478 1 41.6957 1ZM32.3044 39.0974C26.1061 39.0974 21.0974 34.0574 21.0974 27.8591C21.0974 21.6609 26.1061 16.6522 32.3044 16.6522C38.5026 16.6522 43.5113 21.6609 43.5113 27.8591C43.5113 34.0574 38.5026 39.0974 32.3044 39.0974Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5116 27.8593C43.5116 34.0576 38.5029 39.0976 32.3046 39.0976C26.1064 39.0976 21.0977 34.0576 21.0977 27.8593C21.0977 21.661 26.1064 16.6523 32.3046 16.6523C38.5029 16.6523 43.5116 21.661 43.5116 27.8593Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.5b3dc6f7ec7f44d2075f28eae77307c9.svg";
export { ForwardRef as ReactComponent };